<template>
  <v-app id="truple">
    <v-app-bar color="primary" app v-if="!$store.state.inApp">
      <v-expand-transition v-if="isLoggedIn()">
        <v-app-bar-nav-icon @click.stop="drawer = (!drawer && isLoggedIn())"></v-app-bar-nav-icon>
      </v-expand-transition>
      <v-toolbar-title>
        <div class="d-flex align-center">
          <img src="/static/img/logo.3.white.svg" style="width: 32px; height: 32px;" />
          <span class="app-title ml-2">{{ appName }}</span>
        </div>
      </v-toolbar-title>
    </v-app-bar>
    <v-navigation-drawer
            v-if="!$store.state.inApp"
            v-model="drawer"
            fixed
            clipped
            temporary
            app
    >
      <v-list density="compact">
        <v-list-item @click="$router.push('login')" v-if="!isLoggedIn()">
          <template v-slot:prepend>
            <v-icon>account_circle</v-icon>
          </template>

            <v-list-item-title>Sign Up</v-list-item-title>

        </v-list-item>
        <v-list-item @click="$router.push('login')" v-if="!isLoggedIn()">
          <template v-slot:prepend>
            <v-icon>transit_enterexit</v-icon>
          </template>

            <v-list-item-title>Login</v-list-item-title>

        </v-list-item>
        <v-list-item @click="$router.push('home')"  v-if="isLoggedIn()" :disabled="$route.path.toLowerCase().indexOf('home') !== -1 || $route.path.toLowerCase().endsWith('.io/#/') || $route.path.toLowerCase().endsWith('.io/')">
          <template v-slot:prepend>
            <v-icon>home</v-icon>
          </template>

            <v-list-item-title>Home</v-list-item-title>

        </v-list-item>
<!--        <v-list-item @click="$router.push('allscreenshots')"  v-if="isLoggedIn()" :disabled="$route.path.toLowerCase().indexOf('allscreenshots') !== -1 || $route.path.toLowerCase().endsWith('.io/#/allscreenshots')">-->
<!--          <v-list-item-action>-->
<!--            <v-icon>photo</v-icon>-->
<!--          </v-list-item-action>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>All Screenshots</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
        <v-list-item @click="$router.push('filter')"  v-if="isLoggedIn()" :disabled="$route.path.toLowerCase().indexOf('filter') !== -1">
          <template v-slot:prepend>
            <v-icon>security</v-icon>
          </template>

            <v-list-item-title>Web Filter</v-list-item-title>

        </v-list-item>
        <v-list-item @click="$router.push('devices')"  v-if="isLoggedIn()" :disabled="$route.path.toLowerCase().indexOf('devices') !== -1">
          <template v-slot:prepend>
            <v-icon>smartphone</v-icon>
          </template>

            <v-list-item-title>Devices</v-list-item-title>

        </v-list-item>
        <v-list-item @click="$router.push('emails')"  v-if="isLoggedIn()" :disabled="$route.path.toLowerCase().indexOf('emails') !== -1">
          <template v-slot:prepend>
            <v-icon>email</v-icon>
          </template>

            <v-list-item-title>Alerting & Reports</v-list-item-title>

        </v-list-item>
        <v-list-item @click="$router.push('account')" v-if="isLoggedIn()" :disabled="$route.path.toLowerCase().indexOf('account') !== -1">
          <template v-slot:prepend>
            <v-icon>account_box</v-icon>
          </template>

            <v-list-item-title>Account</v-list-item-title>

        </v-list-item>

        <v-list-item @click="$router.push('setup')" v-if="isLoggedIn()" :disabled="$route.path.toLowerCase().indexOf('setup') !== -1">
          <template v-slot:prepend>
            <v-icon>done_all</v-icon>
          </template>

            <v-list-item-title>Setup Guide</v-list-item-title>

        </v-list-item>

<!--        <v-list-item @click="$router.push('updates')" v-if="isLoggedIn()" :disabled="$route.path.toLowerCase().indexOf('updates') !== -1">-->
<!--          <v-list-item-action>-->
<!--            <v-icon>new_releases</v-icon>-->
<!--          </v-list-item-action>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>Update Log</v-list-item-title>-->
<!--&lt;!&ndash;            <v-list-item-subtitle>See whats new</v-list-item-subtitle>&ndash;&gt;-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
        <v-list-item :href="`https://${supportDomain}`" target="_blank">
          <template v-slot:prepend>
            <v-icon>help</v-icon>
          </template>

            <v-list-item-title>Support</v-list-item-title>

        </v-list-item>

        <v-list-item v-if="product !== 'screenkin' && product !== 'bestaccountability'" href="https://stories.truple.io" target="_blank">
          <template v-slot:prepend>
            <v-icon>comment</v-icon>
          </template>

            <v-list-item-title>Community</v-list-item-title>

        </v-list-item>

        <v-list-item @click="$router.push('rating')"  v-if="isLoggedIn() && product !== 'screenkin'" :disabled="$route.path.toLowerCase().indexOf('rating') !== -1 || $route.path.toLowerCase().endsWith('.io/#/rating')">
          <template v-slot:prepend>
            <v-icon>construction</v-icon>
          </template>

            <v-list-item-title>Analyzer</v-list-item-title>

        </v-list-item>
<!--        <v-list-item @click="$router.push('discounts')" v-if="isLoggedIn()" :disabled="$route.path.toLowerCase().indexOf('discounts') !== -1">-->
<!--          <v-list-item-action>-->
<!--            <v-icon>monetization_on</v-icon>-->
<!--          </v-list-item-action>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>Discounts</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
        <v-list-item @click="logoutAwait('navigation-logout', true)" v-if="isLoggedIn()" :disabled="loggingOut">
          <template v-slot:prepend>
            <v-icon v-if="!loggingOut">exit_to_app</v-icon>
            <v-progress-circular indeterminate size="24" v-else class="mr-2"></v-progress-circular>
          </template>

            <v-list-item-title>Logout</v-list-item-title>

        </v-list-item>

        <v-list-item @click="$router.push('debug')" v-if="isLoggedIn() && $store.state.account && $store.state.account.account.debug" :disabled="$route.path.toLowerCase().indexOf('debug') !== -1">
          <template v-slot:prepend>
            <v-icon>bug_report</v-icon>
          </template>

            <v-list-item-title>Debug</v-list-item-title>

        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="mb-12">
      <v-alert v-if="clockSkewDetected"
               type="error"
               variant="tonal"
               density="compact"
               closable
               class="ma-3"
               @click:close="clockSkewDetected = false">
        Your device's clock is off by {{ clockSkewMinutes }} minutes. This causes connection errors. Please set your clock to sync automatically then refresh the page.
      </v-alert>
      <router-view></router-view>
    </v-main>

    <v-snackbar
            v-if="displayUnsupportedBrowser && !$store.state.inApp"
            app
            location="top"
            :timeout="10000"
            v-model="displayUnsupportedBrowser">
      <v-icon color="accent" class="pr-3">new_releases</v-icon>
      <span>For the best experience, please use <a href="https://www.google.com/chrome">Chrome</a>, <a href="http://getfirefox.com">Firefox</a> or <a href="https://www.apple.com/safari/">Safari</a>.</span>
      <v-btn icon size="small" color="primary" class="pr-0 pl-3 pt-0 pb-0 ma-0" @click="displayUnsupportedBrowser = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-snackbar
      v-else-if="displayPastDue"
      app
      location="top"
      :timeout="10000"
      v-model="displayPastDue">
      <v-icon color="accent" class="pr-3">new_releases</v-icon>
      <span>Your account is past due. Please <a @click="fixPaymentInfo" class="text--theme--accent text-decoration-underline">fix your card info</a>.</span>
      <v-btn icon size="small" color="primary" class="pr-0 pl-3 pt-0 pb-0 ma-0" @click="displayPastDue = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-snackbar v-else-if="shouldAskForFeedback && !showFeedbackSurvey"
                app
                location="top end"
                max-width="80vw"
                :timeout="60000"
                v-model="shouldAskForFeedback"
    >
      <div class="d-flex align-center">
        <v-icon color="accent" class="mr-3">poll</v-icon>
        <span class="flex-grow-1">Let us know how we're doing!</span>
        <v-btn icon variant="text" size="small" color="white" class="ml-2" @click="overrideFeedbackRequest = true"><v-icon>close</v-icon></v-btn>
      </div>
      <div class="d-flex justify-end">
        <v-btn variant="text" color="accent" @click="openFeedbackSurvey">
          Take Survey
        </v-btn>
      </div>
    </v-snackbar>
    <v-snackbar
      v-else-if="displayNews"
      app
      location="top end"
      :timeout="15000"
      v-model="displayNews">
      <template v-if="externalNewsUrl">
        <a :href="externalNewsUrl" target="_blank" @click="snackBarClicked()" class="text-white pa-0 ma-0" style="text-decoration: none;">
          <v-icon color="accent" class="pr-3">new_releases</v-icon>
          {{ newsMessage }}
        </a>
      </template>
<!--      <template v-else>-->
<!--        <router-link to="updates" @click.native="snackBarClicked()" class="white&#45;&#45;text pa-0 ma-0" style="text-decoration: none;">-->
<!--          <v-icon color="accent" class="pr-3">new_releases</v-icon>-->
<!--          {{ newsMessage }}-->
<!--        </router-link>-->
<!--      </template>-->
        <v-btn icon size="small" color="primary" class="pr-0 pl-3 pt-0 pb-0 ma-0" @click="closeNews"><v-icon>close</v-icon></v-btn>
    </v-snackbar>

    <survey-feedback v-model="showFeedbackSurvey" @on-close="reloadAccount" />

    <v-footer app absolute>
      <v-spacer></v-spacer>
      <div>
        <span class="text-caption text-medium-emphasis"><a :href="`https://${domain}/privacy.html`" target="_blank" class="text-caption">Privacy</a>&nbsp;&nbsp;<a :href="`https://${domain}/termsofuse.html`" target="_blank" class="text-caption">Terms</a> &copy; 2025 {{appName}} LLC&nbsp;&nbsp;v.{{ appVersion }}&nbsp;&nbsp;</span>
      </div>
      <v-spacer></v-spacer>
    </v-footer>
    <terms-of-service></terms-of-service>
  </v-app>
</template>

<script>
import Bowser from "bowser"
import TermsOfService from '@/components/TermsOfService'
import StoreConstants from '@/StoreConstants'
import EventCache from "@/services/EventCache"
import ReferrerHelper from "@/services/ReferrerHelper";
import SurveyFeedback from "@/components/surveys/SurveyFeedback";
import CouponHelper from "@/services/CouponHelper";
import AWSClockSkewHandler from "@/aws/AWSClockSkewHandler";
const browser = Bowser.getParser(window.navigator.userAgent);

export default {
  name: 'App',
  components: {
    SurveyFeedback,
    TermsOfService
  },
  data() {
    return {
      domain: process.env.VUE_APP_DOMAIN,
      appName: process.env.VUE_APP_NAME,
      supportDomain: process.env.VUE_APP_SUPPORT_DOMAIN,
      product: process.env.VUE_APP_PRODUCT,
      showFeedbackSurvey: false,
      overrideFeedbackRequest: false,
      loggingOut: false,
      drawer: false,
      displayNews: null, //set it below
      newsMessage: 'Cloudflare outage' ,
      externalNewsUrl: 'https://blog.truple.io/2025/11/18/cloudflare-outage.html',
      displayUnsupportedBrowser: null,
      displayPastDue: null,
      appVersion: process.env.VUE_APP_VERSION,
      clockSkewDetected: false,
      clockSkewOffset: 0
    }
  },
  beforeCreate() {
    console.log(`TIMING: App.vue beforeCreate`)
  },
  mounted () {
    console.log(`TIMING: App.vue mounted`)

    ReferrerHelper.run(this.$route.query.href, this.$route.query.referrer)
    CouponHelper.run(this.$route.query.coupon, this.$route.query.onlyAnnual)

    const handleNews = async () => {
      await this.$store.state.accountLoadedPromise

      if(!this.$store.getters.isSubscribed && !this.$store.getters.isAccountabilityPartner) {
        //don't want to show this news to everyone.
        return
      }

      this.displayPastDue = this.$store.getters.isAccountPastDue

      let closedAt = JSON.parse(localStorage.getItem('news-closed-at'))

      if(!closedAt) {
        closedAt = 0;
      }

      // this.displayNews = false
      if(Date.now() - closedAt < 7 * 24 * 60 * 60 * 1000) {
        this.displayNews = false
      }
      else if(Date.now() < 1763553600000){
        //6am on 11/19/2025 end it
        this.displayNews = true
      } else {
        this.displayNews = false
      }
      // else {
      //   this.displayNews = Date.now() < new Date('2024/06/02').getTime()
      //   // this.displayNews = false
      //   // this.displayNews = true
      // }

      // if(this.$store.state.inApp) {
      //   this.displayNews = false;
      // }
    }

    handleNews()

    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  beforeUnmount () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize)
    }

    EventCache.cleanUp()
  },
  created () {

    let timeoutHandler
    this.$store.watch((state) => state.inAppCredentialsExpiresAt, (oldValue, newValue) => {
      if(newValue) {
        let value = parseInt(newValue)
        if(timeoutHandler) {
          clearTimeout(timeoutHandler)
        }
        timeoutHandler = setTimeout(() => {
          this.api.forceLogout('credentialsExpired')
        }, Math.max(Date.now() - (5 * 60 * 1000) - (value * 1000), 0))
      }
    })

    if(this.$route.query.inApp) {
      this.$store.commit(StoreConstants.commits.setInApp)
    }

    this.$store.commit(StoreConstants.commits.setBrowser, browser.parsedResult)

    this.displayUnsupportedBrowser = this.isUnsupportedBrowser

    AWSClockSkewHandler.onSignificantSkew = (offset) => {
      this.clockSkewDetected = true
      this.clockSkewOffset = offset
    }

    this.api.handleIdleLogout()

    window.addEventListener('focus', async () => {
      await this.api.handleIdleLogout()
    })

    window.addEventListener('beforeunload', async () => {
      await this.api.handleIdleLogout()
    })
  },
  methods: {
    openFeedbackSurvey() {
      this.showFeedbackSurvey = true
    },
    reloadAccount() {
      this.$store.dispatch(StoreConstants.actions.loadAccount)
    },
    fixPaymentInfo() {
      this.displayPastDue = false
      this.$router.push({
        path: 'account',
        query: {
          changeCard: true
        }
      })
    },
    closeNews() {
      this.displayNews = false
      localStorage.setItem('news-closed-at', JSON.stringify(Date.now()))
    },
    onResize() {
      let isMobile = window.innerWidth < 600
      this.$store.commit(StoreConstants.commits.setMobile, isMobile)
    },
    snackBarClicked() {
      this.displayNews = false
    },
    isLoggedIn() {
      return this.auth.isLoggedIn()
    },
    async logoutAwait(reason, reload) {
      this.loggingOut = true
      await this.auth.logoutAwait(reason)
      setTimeout(async () => {
        this.loggingOut = false
        if(!reload) {
          await this.$router.push('login')
        } else {
          window.location.reload()
        }
      }, 3000)
    }
  },
  computed: {
    shouldAskForFeedback: {
      get() {
        //disabled by cam on 10/30/2023, setup again once we have it sent to support reps.
        // return false
        return !this.overrideFeedbackRequest && this.$store.getters.shouldAskForFeedback && this.product !== 'screenkin'
      },
      set (val) {
        this.overrideFeedbackRequest = val
      }
    },
    whatsNewContentShown() {
      return this.whatsNewContent.filter(x => {
        return !x.hide
      })
    },
    isUnsupportedBrowser() {
      return this.$store.state.browser.engine.name !== 'Blink' && this.$store.state.browser.browser.name !== 'Chrome' && this.$store.state.browser.browser.name !== 'Firefox' && this.$store.state.browser.browser.name !== 'Safari'
    },
    clockSkewMinutes() {
      return Math.round(Math.abs(this.clockSkewOffset) / 60000)
    }
  }
}
</script>


<style lang="scss">
.text--theme--primary {
  color: $theme-primary !important;
}
.text--theme--accent {
  color: $theme-accent !important;
}
.text--theme--secondary {
  color: $theme-secondary !important;
}

.text--theme--error {
  color: $theme-error !important;
}

.text--theme--warning {
  color: $theme-warning !important;
}

.app-title {
  font-weight: 300 !important;
  font-size: 1.3rem !important;
  letter-spacing: 0.02em;
}

.v-app-bar {
  border-bottom: 3px solid $theme-accent !important;
}

</style>

<style>

  /* Vuetify 3 no longer styles anchor tags with the primary color by default */
  /* v-dialog renders in v-overlay outside .v-application, so target both */
  .v-application a,
  .v-overlay a {
    color: rgb(var(--v-theme-primary)) !important;
  }
  .v-application a:visited,
  .v-overlay a:visited {
    color: rgb(var(--v-theme-primary)) !important;
  }

  #drift-widget-container { z-index: 4 !important;}

  /* Vuetify 2 icon buttons were flat (no background/shadow) by default.
     Vuetify 3 defaults to 'elevated', so restore the old behavior. */
  .v-btn--icon {
    background: transparent !important;
    box-shadow: none !important;
  }

  .v-card__text, .v-card__title {
    word-break: normal; /* maybe !important  see https://github.com/vuetifyjs/vuetify/issues/9130 */
  }

  /* Vuetify 3 card-actions has 8px padding vs 16px for title/text — align them */
  .v-card-actions {
    padding: 0.5rem 1rem;
  }

  .centered {
    display: table;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .centered2 {
    margin-left:auto;
    margin-right:auto;
    display: table;
  }

  .clickable {
    cursor: pointer;
  }

  /* SweetAlert2 default z-index (1060) is below Vuetify dialogs (~2400+) */
  .swal2-container {
    z-index: 10000 !important;
  }

</style>
